"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
var _echarts = _interopRequireDefault(require("echarts"));
var _index = require("@/utils/index");
var _china = _interopRequireDefault(require("echarts/map/json/china.json"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_echarts.default.registerMap('china', _china.default);
require('echarts/theme/macarons'); // echarts theme
var animationDuration = 3000;
var _default = exports.default = {
  name: 'portrait',
  components: {},
  data: function data() {
    return {
      user_type: '0',
      date_type: '0',
      user_title: ['新增用户数', '活跃用户数'],
      visit_uv_current: {},
      visit_uv_new: {},
      visit_uv: {},
      uv_total: {}
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    /**
     * 选择用户类型
     */
    selUser: function selUser() {
      this.visit_uv_current = this.user_type == 1 ? this.visit_uv : this.visit_uv_new;
      this.setEChart();
    },
    /**
     * 选择时间
     */
    selTime: function selTime() {
      this.getData();
    },
    /**
     * 获取数据
     */
    getData: function getData() {
      var _this = this;
      this.$get('agentapi/analysis/wx_user_portrait', {
        date_type: this.date_type
      }).then(function (res) {
        var city_uv_new = 0,
          province_uv_new = 0,
          city_uv = 0,
          province_uv = 0;
        for (var i in res.visit_uv_new.city) {
          city_uv_new += res.visit_uv_new.city[i].value;
        }
        for (var i in res.visit_uv_new.province) {
          province_uv_new += res.visit_uv_new.province[i].value;
        }
        for (var i in res.visit_uv.city) {
          city_uv += res.visit_uv.city[i].value;
        }
        for (var i in res.visit_uv.province) {
          province_uv += res.visit_uv.province[i].value;
        }
        _this.uv_total = [{
          city_uv: city_uv_new,
          province_uv: province_uv_new
        }, {
          city_uv: city_uv,
          province_uv: province_uv
        }];
        _this.visit_uv_current = res.visit_uv_new;
        _this.visit_uv_new = res.visit_uv_new;
        _this.visit_uv = res.visit_uv;
        _this.setEChart();
      });
    },
    /**
     * 设置图表
     */
    setEChart: function setEChart() {
      this.genderEChart();
      this.ageEChart();
      this.mapEChart();
      this.platformsEChart();
      this.devicesEChart();
    },
    /**
     * 性别图表设置数据
     */
    genderEChart: function genderEChart() {
      var that = this;
      this.EChart = _echarts.default.init(document.getElementById('genderEChart'), 'macarons');
      this.EChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          top: 20,
          left: 20,
          itemGap: 15,
          itemWidth: 15,
          itemHeight: 15,
          textStyle: {
            fontSize: 14,
            padding: [2, 0, 0, 0]
          }
        },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          label: {
            // 饼图图形上的文本标签
            normal: {
              show: true,
              lineHeight: 20,
              textStyle: {
                fontWeight: 300,
                fontSize: 12 // 文字的字体大小
              },
              formatter: '{b}({d}%)' // {b}\n
            }
          },
          data: that.visit_uv_current.genders
        }]
      });
    },
    /**
     * 年龄段图表设置数据
     */
    ageEChart: function ageEChart() {
      var that = this;
      var xAxis_data = [],
        series_data = [];
      for (var i in this.visit_uv_current.ages) {
        var age = this.visit_uv_current.ages[i];
        xAxis_data.push(age.name);
        series_data.push(age.value);
      }
      this.EChart = _echarts.default.init(document.getElementById('ageEChart'), 'macarons');
      this.EChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: 40,
          left: 20,
          right: 20,
          bottom: 40,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: xAxis_data,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        series: [{
          type: 'bar',
          stack: 'vistors',
          barWidth: '40%',
          data: series_data,
          animationDuration: animationDuration
        }]
      });
    },
    /**
     * 地图图表设置数据
     */
    mapEChart: function mapEChart() {
      var that = this,
        province = that.visit_uv_current.province,
        max_num = 0;
      for (var i in province) {
        max_num = max_num && max_num > province[i].value ? max_num : province[i].value;
        if (province[i].name.indexOf('省') > -1) province[i].name = province[i].name.replace('省', '');
      }
      this.EChart = _echarts.default.init(document.getElementById('mapEChart'), 'macarons');
      this.EChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        visualMap: {
          min: 0,
          max: max_num,
          left: 20,
          bottom: 20,
          text: ['高', '低'],
          // 文本，默认为数值文本
          calculable: true
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: false
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        series: [{
          name: this.user_title[this.user_type],
          type: 'map',
          mapType: 'china',
          zoom: 1.1,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            areaColor: '#f5ffff'
          },
          data: that.visit_uv_current.province
        }]
      });
    },
    /**
     * 终端图表设置数据
     */
    platformsEChart: function platformsEChart() {
      var that = this;
      this.EChart = _echarts.default.init(document.getElementById('platformsEChart'), 'macarons');
      this.EChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          top: 20,
          left: 20,
          itemGap: 15,
          itemWidth: 15,
          itemHeight: 15,
          textStyle: {
            fontSize: 14,
            padding: [2, 0, 0, 0]
          }
        },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          label: {
            // 饼图图形上的文本标签
            normal: {
              show: true,
              lineHeight: 20,
              textStyle: {
                fontWeight: 300,
                fontSize: 12 // 文字的字体大小
              },
              formatter: '{b}({d}%)' // {b}\n
            }
          },
          data: that.visit_uv_current.platforms
        }]
      });
    },
    /**
     * 机型图表设置数据
     */
    devicesEChart: function devicesEChart() {
      var that = this;
      this.EChart = _echarts.default.init(document.getElementById('devicesEChart'), 'macarons');
      this.EChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          top: 20,
          left: 20,
          itemGap: 15,
          itemWidth: 15,
          itemHeight: 15,
          textStyle: {
            fontSize: 14,
            padding: [2, 0, 0, 0]
          }
        },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          label: {
            // 饼图图形上的文本标签
            normal: {
              show: true,
              lineHeight: 20,
              textStyle: {
                fontWeight: 300,
                fontSize: 12 // 文字的字体大小
              },
              formatter: '{b}({d}%)' // {b}\n
            }
          },
          data: that.visit_uv_current.devices
        }]
      });
    }
  }
};